/* import __COLOCATED_TEMPLATE__ from './create-invite-bulk.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./create-invite-bulk.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());